import React from 'react';

// Styles
import './WpGif.scss';

type Props = {
  url: string;
};

const WpGif = ({ url }: Props) => {
  const baseClassName = 'WpGif';
  return (
    <div className={baseClassName}>
      <img src={url} className={`${baseClassName}__img`} />
    </div>
  );
};

export default WpGif;
